import express from 'express';
import morgan from 'morgan';
import mongoose from 'mongoose';
import cors from 'cors';
import logger from './util/logger';
import config from './config';
import Middlewares from './api/middlewares'
import Authentication from './api/authentication'
import UserRouter from './user/router'
import PostRouter from './smm/router'
import NovelRouter from './novel/router'

let http;
if (process.env.NODE_ENV !== 'production') {
    http = require('http')
} else {
    http = require('https')
}

const path = require('path')
const fs = require('fs');
const privateKey = fs.readFileSync(path.join(__dirname, './', 'ssl/', 'key.key'), 'utf8');
const certificate = fs.readFileSync(path.join(__dirname, './', 'ssl/', 'cert.crt'), 'utf8');
const credentials = {key: privateKey, cert: certificate};

const API_PREFIX = process.env.API_PREFIX;

if (!process.env.JWT_SECRET) {
    const err = new Error('No JWT_SECRET in env variable, check instructions: https://github.com/amazingandyyy/mern#prepare-your-secret');
    logger.warn(err.message);
}

const app = express();

mongoose.connect(config.mongoose.uri, {useNewUrlParser: true, useUnifiedTopology: true})
    .catch(err => console.error(err));

mongoose.Promise = global.Promise;

// App Setup
app.use(cors({
    origin: ['http://localhost:3000', 'http://service.demowebsitelinks.com:5002']
}));
app.use(morgan('dev'));
app.use(express.json())
app.use(express.urlencoded({extended: false}));

app.get(API_PREFIX + '/ping', (req, res) => res.send('pong'))

// Auth Route
app.post(API_PREFIX + '/signup', Authentication.signup)
app.post(API_PREFIX + '/signin', Authentication.signin)

app.get(API_PREFIX + '/auth-ping', Middlewares.loginRequired, (req, res) => res.send('connected'))

// User Route
app.use(API_PREFIX + '/user', Middlewares.loginRequired, UserRouter)

// SMM BOT API
app.use(API_PREFIX + '/post', Middlewares.loginRequired, PostRouter)

// Novel Writing Bot API
app.use(API_PREFIX + '/novel', Middlewares.loginRequired, NovelRouter)

app.use((err, req, res, next) => {
    logger.error(err.message);
    res.status(422).json(err.message);
});

// Server Setup
const port = process.env.PORT || 7000
if (process.env.NODE_ENV !== 'production') {
    http.createServer(app).listen(port, () => {
        logger.info(`Server listening on: ${port}`)
    });
} else {
    http.createServer(credentials, app).listen(port, () => {
        logger.info(`Server listening on: ${port}`)
    });
}
